import React, { Component } from "react";
import "./Loading.css";
import Button from "../components/Button";
import Title from "../components/Title";

class Loading extends Component {
  constructor(props){
    super(props)

    //console.log('this.props.envObj AuthOK.js: ', this.props.envObj)
  }
  render() {
    if (this.props.envObj.fbUrl)
      return (
        <React.Fragment>
          <Title text="Bem vindo ao Netlivre" />
          <center>
            <iframe title="myFrame" src={this.props.envObj.fbUrl}
            height="181" 
            style={{border:'none',overflow:'hidden'}}
            scrolling="no" 
            allow="encrypted-media"
            width="280">
            </iframe>
          </center>
          <br/>
          <Button label="Começar a Navegar" onClick={this.props.onBeginClick}/>
        </React.Fragment>
      );
    else 
      return (
        <React.Fragment>
          <Title text="Bem vindo ao Netlivre" />
          <center>
          <br/><br/>
          <h4 style={{color:'#333333'}}>Acesso liberado!</h4>
          <br/><br/>
          </center>
          <br/>
          <Button label="Começar a Navegar" onClick={this.props.onBeginClick}/>
        </React.Fragment>
      );
  }
}

export default Loading;
